import { motion } from "framer-motion";
import { memo } from "react";
import Separator from "../../../../../core/components/Separator.tsx";
import FiltroData from "../../../../../core/data-entry/FiltroData.tsx";
import { formatDate } from "../../../../../core/utils/formatDate.ts";
import { BuscarRelatorioKmProps } from "../../../../../services/ModuloGerenciador/Motorista.ts";
import TextField from "../../../Embarque/components/data-entry/TextField.tsx";
import IconButton from "../../../../../core/components/IconButton.tsx";

interface ClassificacaoPontosHeaderProps {
	valuesPesquisa: BuscarRelatorioKmProps;
	setValuesPesquisa: React.Dispatch<
		React.SetStateAction<BuscarRelatorioKmProps>
	>;
	handleSearch?: () => void;
	clearSearch?: () => void;
}

function ClassificacaoPontosHeader({
	valuesPesquisa,
	setValuesPesquisa,
	handleSearch = () => {},
	clearSearch = () => {},
}: ClassificacaoPontosHeaderProps) {
	return (
		<div className="classificacao-pontos-header">
			<div className="filtro-data-container">
				<FiltroData
					title="Início"
					value={valuesPesquisa.dataInicio}
					onChange={(value) =>
						setValuesPesquisa((prev) => ({
							...prev,
							dataInicio: formatDate(value),
						}))
					}
				/>
				<div className="filtro-data-divider" />
				<FiltroData
					title="Fim"
					titleFrente={false}
					value={valuesPesquisa.dataFinal}
					onChange={(value) =>
						setValuesPesquisa((prev) => ({
							...prev,
							dataFinal: formatDate(value),
						}))
					}
				/>
			</div>
			<Separator size="md" direction="horizontal" />
			<div
				style={{
					display: "flex",
					alignItems: "center",
					maxWidth: "200px",
					flex: 1,
				}}
			>
				<TextField
					placeholder="Ponto Km"
					value={String(valuesPesquisa.pontoKm)}
					label="Ponto Km"
					onChange={(value) =>
						setValuesPesquisa((prev) => ({
							...prev,
							pontoKm: parseFloat(value) || 0,
						}))
					}
				/>
			</div>
			<Separator size="md" direction="horizontal" />
			<div
				style={{
					display: "flex",
					alignItems: "center",
					maxWidth: "200px",
					flex: 1,
				}}
			>
				<TextField
					placeholder="Ponto Viagem"
					value={String(valuesPesquisa.pontoViagem)}
					label="Ponto Viagem"
					onChange={(value) =>
						setValuesPesquisa((prev) => ({
							...prev,
							pontoViagem: parseFloat(value) || 1200,
						}))
					}
				/>
			</div>
			<IconButton
				icon="Search"
				theme="dark"
				size="xl"
				borderColor="none"
				backgroundColor="#FFFFFF"
				hoverColor="#CCC"
				onClick={handleSearch}
			/>
			<motion.div
				initial={{ rotate: 0 }}
				whileHover={{ rotate: 90 }}
				transition={{ duration: 0.2, ease: "easeInOut" }}
				className="select-field-chevron"
			>
				<IconButton
					icon="X"
					size="xl"
					borderColor="none"
					onClick={clearSearch}
					backgroundColor="rgba(0, 0, 0, 0)"
					theme="dark"
				/>
			</motion.div>
		</div>
	);
}

export default memo(ClassificacaoPontosHeader);
